import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../../../config'

function FormRenderCard({ item, reloadList = () => {}}) {
    const [values, setValues] = useState({})
    const [loading, setLoading] = useState(false)

    function formatDateTime(isoString, opt) {
        const date = new Date(isoString);

        let options = opt || {
            weekday: 'long',   // "Saturday"
            year: 'numeric',    // "2026"
            month: 'short',     // "Jan"
            day: 'numeric',     // "3"
            hour: '2-digit',    // "07"
            minute: '2-digit',  // "30"
            hour12: true        // "AM/PM"
        };

    return new Intl.DateTimeFormat('en-US', options).format(date);
    }

    // 🔹 Handle input change
    const handleChange = (field, value) => {
        console.log(field, value);
        if (field.type === 'checkbox') {
            const prev = values[field.id] || []
            if (prev.includes(value)) {
                setValues({
                    ...values,
                    [field.id]: prev.filter(v => v !== value),
                })
            } else {
                setValues({
                    ...values,
                    [field.id]: [...prev, value],
                })
            }
        } else {
            setValues({
                ...values,
                [field.id]: value,
            })
        }
    }

    // 🔹 Submit form
    const handleSubmit = async (e) => {
        e.preventDefault()

        // 🔒 Required field validation
        for (const field of item.Data.fields) {
            if (field.required && !values[field.id]) {
                toast.error(`${field.label} is required`)
                return
            }
        }

        const payload = {
            PostID: item.ID,
            Type: 'Form',
            Data: {
                values,
            },
        }

        try {
            setLoading(true)

            await axios.post(
                `${config.apiUrl}/submissions/post/submit`,
                payload,
                {
                    headers: {
                        Authorization: `${localStorage.getItem('token')}`,
                    },
                }
            )

            toast.success('Form submitted successfully')
            setValues({})
            reloadList();
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message || 'Submission failed')
        } finally {
            setLoading(false)
        }
    }
    console.log(item)
    return (
        <>
            <div className="bl-form-head mb-3">
                <h3 className="poll-question mb-1">
                    {item.Data?.title || `Form #${item.Data?.FormID || 'Unknown'}`}
                </h3>
                {item.Data?.description && (
                    <p className="text-muted small mb-0">
                        {item.Data?.description}
                    </p>
                )}
                {item.MySubmission && (
                    <span className="bl-chip bl-chip--primary mt-2">
                        <ion-icon name="checkmark-circle-outline" aria-hidden="true"></ion-icon>
                        Submitted
                    </span>
                )}
            </div>

            {item.Data?.fields?.length > 0 ? (
                <>
                {
                    item.MySubmission ? 
                    <>
                        {item.Data.fields.map((f, index) => (
                            <div key={`${item.ID}-${f.id}`} className="bl-answer">
                                <div className="bl-answer__label">
                                    {f.label}
                                </div>

                                <p className="bl-answer__value">

                                    {/* TEXT */}
                                    {f.type === 'text' && (
                                        <>{item?.MySubmission?.Data?.values[f.id]}</>
                                    )}

                                    {/* NUMBER */}
                                    {f.type === 'number' && (
                                        <>{item?.MySubmission?.Data?.values[f.id]}</>
                                    )}

                                    {/* TEXTAREA */}
                                    {f.type === 'textarea' && (
                                         <>{item?.MySubmission?.Data?.values[f.id]}</>
                                    )}

                                    {/* DATE */}
                                    {f.type === 'date' && (
                                        <>{item?.MySubmission?.Data?.values[f.id] ? formatDateTime(item?.MySubmission?.Data?.values[f.id], {weekday: 'long',year: 'numeric',month: 'short',day: 'numeric'}) : ''}</>
                                    )}

                                    {/* DATETIME */}
                                    {f.type === 'datetime' && (
                                        <>{item?.MySubmission?.Data?.values[f.id] ? formatDateTime(item?.MySubmission?.Data?.values[f.id]) : ''}</>
                                    )}

                                    {/* RADIO / CHECKBOX */}
                                    {(f.type === 'radio') &&
                                        <>{item?.MySubmission?.Data?.values[f.id]}</>
                                    }
                                    {(f.type === 'checkbox') &&
                                        <>{item?.MySubmission?.Data?.values[f.id]?.join(', ')}</>
                                    }

                                    {/* SELECT */}
                                    {f.type === 'select' && (
                                        <>{item?.MySubmission?.Data?.values[f.id]}</>
                                    )}
                                </p>
                            </div>
                        ))}
                    </>
                    :
                    <form onSubmit={handleSubmit}>
                        {item.Data.fields.map((f, index) => (
                            <div key={`${item.ID}-${f.id}`} className="mb-3">
                                {(f.type === 'radio' || f.type === 'checkbox') ? (
                                    <div className="form-label" id={`${item.ID}-${f.id}-label`}>
                                        {f.label}
                                        {f.required && <span className="text-danger ms-1" aria-hidden="true">*</span>}
                                    </div>
                                ) : (
                                    <label className="form-label" htmlFor={`${item.ID}-${f.id}`}>
                                        {f.label}
                                        {f.required && <span className="text-danger ms-1" aria-hidden="true">*</span>}
                                    </label>
                                )}

                                {/* TEXT */}
                                {f.type === 'text' && (
                                    <input
                                        id={`${item.ID}-${f.id}`}
                                        aria-required={!!f.required}
                                        className="form-control"
                                        placeholder={f.placeholder || ''}
                                        value={values[f.id] || ''}
                                        onChange={(e) => handleChange(f, e.target.value)}
                                    />
                                )}

                                {/* NUMBER */}
                                {f.type === 'number' && (
                                    <input
                                        type="number"
                                        id={`${item.ID}-${f.id}`}
                                        aria-required={!!f.required}
                                        className="form-control"
                                        value={values[f.id] || ''}
                                        onChange={(e) => handleChange(f, e.target.value)}
                                    />
                                )}

                                {/* TEXTAREA */}
                                {f.type === 'textarea' && (
                                    <textarea
                                        id={`${item.ID}-${f.id}`}
                                        aria-required={!!f.required}
                                        className="form-control"
                                        rows="3"
                                        value={values[f.id] || ''}
                                        onChange={(e) => handleChange(f, e.target.value)}
                                    />
                                )}

                                {/* DATE */}
                                {f.type === 'date' && (
                                    <input
                                        type="date"
                                        id={`${item.ID}-${f.id}`}
                                        aria-required={!!f.required}
                                        className="form-control"
                                        value={values[f.id] || ''}
                                        onChange={(e) => handleChange(f, e.target.value)}
                                    />
                                )}

                                {/* DATETIME */}
                                {f.type === 'datetime' && (
                                    <input
                                        type="datetime-local"
                                        id={`${item.ID}-${f.id}`}
                                        aria-required={!!f.required}
                                        className="form-control"
                                        value={values[f.id] || ''}
                                        onChange={(e) => handleChange(f, e.target.value)}
                                    />
                                )}

                                {/* RADIO / CHECKBOX */}
                                {(f.type === 'radio' || f.type === 'checkbox') &&
                                    f.options?.map((o, i) => (
                                        <div className="form-check" key={i}>
                                            <input
                                                className="form-check-input"
                                                id={`${item.ID}-${f.id}-${i}`}
                                                type={f.type}
                                                name={`${item.ID}-${f.id}`}
                                                // checked={
                                                //     f.type === 'checkbox'
                                                //         ? (values[f.id] || []).includes(o)
                                                //         : values[f.id] === o
                                                // }
                                                onChange={() => handleChange(f, o)}
                                            />
                                            <label className="form-check-label" htmlFor={`${item.ID}-${f.id}-${i}`}>{o}</label>
                                        </div>
                                    ))}

                                {/* SELECT */}
                                {f.type === 'select' && (
                                    <select
                                        id={`${item.ID}-${f.id}`}
                                        aria-required={!!f.required}
                                        className="form-select"
                                        value={values[f.id] || ''}
                                        onChange={(e) => handleChange(f, e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {f.options?.map((o, i) => (
                                            <option key={i} value={o}>{o}</option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        ))}

                        <Button
                            type="submit"
                            variant="primary"
                            className="w-100"
                            disabled={loading}
                        >
                            {loading && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
                            {loading ? 'Submitting...' : item.Data?.submittext || 'Submit'}
                        </Button>
                    </form>
                }
                </>
            ) : (
                <p className="text-muted small mb-0">No fields configured for this form</p>
            )}
        </>
    )
}

export default FormRenderCard